// FIXME: THIS CHARGBEE PAYMENT FORM COMPONENT IS NOT BEING USED ANYMORE. IT'S BEEN REPLACED BY CHARGEBEE CHECKOUT

'use client';
import React, { useRef, useState } from 'react';
import Image from 'next/image';
import { classNames } from '@/lib/utils';
import { useLoggedInUser } from '@/hooks/useLoggedInUser';
import { CardComponent, CardCVV, CardExpiry, CardNumber } from '@chargebee/chargebee-js-react-wrapper';
import { LoadingSpinner } from './LoadingSpinner';
import { Button } from '@/components/presentational/tailwind/Button';
import { countryList } from '@/constants';
import { chargebeeToUse } from '@shared-libs/utils/helpers';
import StripeIcon from '@public/img/icons/stripe-secured.svg';
import { LockClosedIcon, XCircleIcon } from '@heroicons/react/20/solid';
// import { XMarkIcon } from '@heroicons/react/24/solid';

export default function ChargebeePaymentForm({
  children,
  className,
  // onClose,
  selectedPlan,
  selectedYearly,
  selectedAccount,
  selectedUsername,
  accountColor,
  isFromSetup,
  userCountry = 'US',
}: {
  children?: React.ReactNode;
  className?: string;
  // onClose: () => void;
  selectedPlan: any;
  selectedYearly: boolean;
  selectedAccount?: any;
  selectedUsername?: string;
  accountColor?: string;
  isFromSetup?: boolean;
  userCountry?: string;
}) {
  const [isComponentLoading, setIsComponentLoading] = useState(true);
  const [isLoadingPayment, setIsLoadingPayment] = useState(false);
  const [hideCardLogos, setHideCardLogos] = useState(false);
  const [customerName, setCustomerName] = useState('');
  const [selectedCountry, setSelectedCountry] = useState(userCountry);
  const [showCountryDropdown, setShowCountryDropdown] = useState(false);
  const [zipCode, setZipCode] = useState('');
  const [showZipCode, setShowZipCode] = useState(false);
  const nameInputRef = useRef(null);
  const user = useLoggedInUser();

  // Chargebee
  let cardRef = useRef(null);
  const [errorMessage, setErrorMessage] = useState(null);
  function onPaymentFormSubmit(e) {
    console.log('just submitted chargebee card component');
    if (e) e.preventDefault();
    // Validate customer name
    nameInputRef.current.classList.remove('ring-1', 'ring-red-500');
    if (!customerName.trim()) {
      setErrorMessage('Please enter your name.');
      nameInputRef.current.focus();
      nameInputRef.current.classList.add('ring-1', 'ring-red-500');
      return;
    }

    console.log(cardRef);
    console.log('tokenizing....');
    // TODO: Look into 3dsecure payments
    // cardRef.current.authorizeWith3ds(paymentIntent, additionalData, callbacks).then(paymentIntent => {
    //     // Send ajax call to create a subscription or to create a card payment source using the paymentIntent ID
    //   }).catch(error => {
    //     console.log(error);
    //   });
    setErrorMessage(null); // Clear any previous errors
    setIsLoadingPayment(true);
    console.log(cardRef.current)

    // Extract first and last name from user's name (customerName)
    let [firstName, ...otherNames] = customerName.split(' ');
    let lastName = otherNames.length > 0 ? otherNames.join(' ') : firstName;

    let tokenizeParams = {
      firstName: firstName,
      lastName: lastName,
      // billingAddr1: "1600 Amphitheatre Parkway",
      // billingCity: "Mountain View",
      // billingState: "California",
      // billingStateCode: "CA",
      ...(showZipCode && zipCode ? { billingZip: zipCode } : {}),
      billingCountry: selectedCountry,
      email: user.email
    }
    console.log('Tokenizing with params', tokenizeParams);

    // FIXME: This is a temporary fix to use the a hardcoded chargebee site and api key
    // const chargebeeSettings = chargebeeToUse() == process.env.NEXT_PUBLIC_CHARGEBEE_SITE
    // ? { site: process.env.NEXT_PUBLIC_CHARGEBEE_SITE, publishableKey: process.env.NEXT_PUBLIC_CHARGEBEE_API_KEY }
    // : { site: process.env.NEXT_PUBLIC_CHARGEBEE_B_SITE, publishableKey: process.env.NEXT_PUBLIC_CHARGEBEE_B_API_KEY }
    const chargebeeSettings = { site: process.env.NEXT_PUBLIC_CHARGEBEE_SITE, publishableKey: process.env.NEXT_PUBLIC_CHARGEBEE_API_KEY }

    cardRef.current.tokenize(tokenizeParams)
      .then((data) => {
        console.log('chargebee token', data.token);
        var chargeParams = {
          token: data.token,
          firstName: firstName,
          lastName: lastName,
          billingCountry: selectedCountry,
          billingZip: zipCode,
          username: selectedAccount ? selectedAccount.data.username : selectedUsername,
          plan: selectedPlan.name,
          amount: String(selectedYearly ? parseInt(selectedPlan.price.YearlyTotal) : selectedPlan.price.Monthly),
          upgradeFromSetup: selectedAccount ? false : true, // If true, subscription won't have a trial period. If false, subscription will have a trial period
          accountColor,
          site: chargebeeSettings.site,
        };
        console.log('chargeParams', chargeParams);

        // Perform a POST request to /api/chargebee/create-subscription and pass the token in the body
        fetch('/api/chargebee/create-subscription', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(chargeParams),
        })
          .then((res) => res.json())
          .then((data) => {
            console.log('chargebee data', data);
            if (data.success) {
              let accountId = data.accountId || selectedAccount.data.id;
              // Redirect to the account page
              window.location.href = (`/app/account/${accountId}?upgraded=true`);
              // onClose();
            } else if (data.error) {
              setIsLoadingPayment(false);
              console.error(`❌ Payment error: `);
              console.error(data.error);
              setErrorMessage(data.error);
              setShowCountryDropdown(true);
            }
          });
      })
      .catch((error) => {
        console.error(`❌ Tokenization error: `);
        console.error(error);
        setIsLoadingPayment(false);
        setErrorMessage(error.message);
        setShowCountryDropdown(true);
      });
  }
  function onCardReady(event) {
    console.log('🚀 ~ file: ChargebeePaymentForm.tsx:68 ~ onCardComponentReady ~ event', event);
    console.log('Card component is ready!');
    setIsComponentLoading(false);
  }
  function onCardFocus(event) {
    // console.log('card focussed yoooo!!!');
    console.log('🚀 ~ file: ChargebeePaymentForm.tsx:72 ~ onFocus ~ event', event);
  }
  function onCardChange(event) {
    // console.log('🚀 ~ file: UpgradeModal.tsx:36 ~ onCardChange ~ event', event);

    var errorsCopy = {};
    var errorMessageCopy;
    if (event.error) {
      // If error is present, setState and display the error
      errorsCopy[event.field] = event.error;
      errorMessageCopy = event.error.message;
    } else {
      errorsCopy[event.field] = null;
      // If there's no error, check for existing error
      const _errors = Object.values(errorsCopy).filter((val) => val);

      // The errorObject holds a message and code
      // Custom error messages can be displayed based on the error code
      const errorObj = _errors.pop();
      console.log("errorObj", errorObj);

      // Display existing message
      if (errorObj) errorMessageCopy = (errorObj as { message: string }).message;
      else errorMessageCopy = '';
    }
    // if (errorsCopy)
    //   setErrors(errorsCopy);
    if (errorMessageCopy)
      setErrorMessage(errorMessageCopy);
  }
  const { style, classes, locale, placeholder, fonts } = {
    style: {
      base: {
        color: '#364963',
        fontWeight: '400',
        fontFamily: 'Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif',
        fontSize: '16px',
        // iconColor: 'transparent',
        fontSmoothing: 'antialiased',
        ':-webkit-autofill': {
          color: '#364963',
        },
        ':focus': {
          color: '#424770',
          iconColor: '#364963',
        },
        '::placeholder': { color: '#364963' },
        ':focus::placeholder': { color: '#7b808c' },
      },
      invalid: {
        color: '#df1b41',
        ':focus': { color: '#df1b41' },
        '::placeholder': { color: '#FFCCA5' },
      },
    },
    classes: {
      focus: 'focus',
      invalid: 'invalid',
      empty: 'empty',
      complete: 'complete',
    },
    locale: 'en',
    placeholder: 'Card Number',
    fonts: [
      'https://fonts.googleapis.com/css?family=Inter:wght@400;500;600;700&display=swap',
    ],
  };

  // if (!(typeof window !== 'undefined' && window.Chargebee)) {
  //   return <p>loading chargebee...</p>
  // }

  return (
    <>
      {errorMessage && (
        <div className="p-4 mt-6 bg-red-100 border-red-500 rounded-xl border-1">
          <div className="flex items-center justify-between">
            <div className="flex">
              <div className="flex-shrink-0">
                <XCircleIcon className="w-6 h-6 text-red-400" aria-hidden="true" />
              </div>
              <div className="ml-3">
                <p className="text-red-700 text-md">
                  {errorMessage}
                  <a href="#" className="font-medium text-red-700 underline hover:text-yellow-600"></a>
                </p>
              </div>
            </div>
            <div className="relative flex-shrink-0">
              <button onClick={() => setErrorMessage(null)} className="align-middle">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="p-1 text-red-500 transition-all duration-200 ease-in-out transform rounded-full w-7 h-7 hover:bg-red-200">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      )}

      <form>
        {isComponentLoading && (
          <div className="relative h-[300px] w-full">
            <div role="status" className="absolute -translate-x-1/2 -translate-y-1/2 top-2/4 left-1/2">
              {/* <Spinner aria-label="Center-aligned spinner example" color="purple" size="lg" /> */}
              <svg className="w-8 h-8 mr-2 text-gray-200 animate-spin fill-indigo-600 dark:text-gray-600" aria-hidden="true" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" /><path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
              </svg>
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        )}

        <CardComponent
          ref={cardRef}
          className={classNames('fieldset field',
            isComponentLoading ? 'hidden' : ''
          )}
          styles={style}
          classes={classes}
          locale={locale}
          placeholder={placeholder}
          fonts={fonts}
          onChange={onCardChange}
          onReady={onCardReady}
          onFocus={onCardFocus}
        >
          <div className="grid grid-cols-3 mt-6 gap-y-3 gap-x-5 sm:grid-cols-4">

            <div className="col-span-full">
              <label className="flex items-end font-medium text-gray-700 place-content-between md:items-center text-md font-dashboard" htmlFor="card-number">
                <span className={classNames("relative bottom-[-5px] inline-flex whitespace-nowrap md:whitespace-normal",
                  isFromSetup ? "text-lg" : "text-md"
                )}>
                  <span className='my-auto'>Enter your payment details</span>
                  <LockClosedIcon className="ml-1.5 h-4 w-4 text-green-400 my-auto saturate-[1.5]" aria-hidden="true" />
                </span>
                <div className="group flex items-center rounded-lg px-2 py-[3px] transition-all duration-300 ease-in hover:bg-indigo-500">
                  <span className="hidden mr-1 text-xs font-medium text-indigo-300 group-hover:text-white md:block">
                    Secured by
                  </span>
                  <StripeIcon className="group-hover:text-white" color="var(--color-indigo-400)" />
                </div>
              </label>
              {isFromSetup && (
                <p className='mt-2 text-xs text-gray-500'>
                  You will <b>not</b> be charged today. You can cancel your trial at anytime.
                </p>
              )}
            </div>

            {/* Customer Name */}
            <div className="col-span-full">
              {/* {!isFromSetup && (<label className="block text-sm font-medium text-gray-700" htmlFor="name">Name</label>)} */}
              <div className="mt-1">
                <input ref={nameInputRef} className="ex1-input shadow-xs mt-1 block w-full rounded-xl border-1 border-gray-300 py-3.5 px-4 pl-5 text-[1.03rem] focus:border-indigo-500 focus:ring-indigo-500 placeholder-[#3a4961]"
                  id="name" type="text" placeholder='Name' required autoComplete='name' aria-label='Name' aria-required="true" maxLength={50}
                  pattern="[A-Za-z\s]*" title="Please enter a valid name. Special characters and numbers are not allowed."
                  onInput={(e) => e.currentTarget.value = e.currentTarget.value.replace(/^(.)|\s+(.)/g, c => c.toUpperCase())}
                  onKeyDown={(e) => { if (!/[a-zA-Z\s]/.test(e.key)) e.preventDefault(); }}
                  onChange={(e) => {
                    setCustomerName(e.target.value);
                    if (e.target.value.trim()) nameInputRef.current.classList.remove('ring-1', 'ring-red-500');
                  }}
                />
              </div>
            </div>

            {/* Card Number */}
            <div className="relative col-span-full">
              <div className="absolute top-0 bottom-0 flex items-center justify-end text-base transition-all duration-150 ease-in-out bg-transparent outline-none pointer-events-none p-CardIcons Input right-5">
                <div className={classNames("flex items-center p-CardBrandIcons p-CardBrandIcons--loaded p-CardBrandIcons--multiple gap-1 transition-all duration-500 ease-in-out pointer-events-none",
                  hideCardLogos ? "opacity-0 visibility-hidden" : ""
                )}>
                  <div className="p-CardBrandIcons-item">
                    <Image src="https://js.stripe.com/v3/fingerprinted/img/visa-729c05c240c4bdb47b03ac81d9945bfe.svg" className="p-CardBrandIcon" role="presentation" width={32} height={20} alt="Visa" />
                  </div>
                  <div className="p-CardBrandIcons-item">
                    <Image src="https://js.stripe.com/v3/fingerprinted/img/mastercard-4d8844094130711885b5e41b28c9848f.svg" className="p-CardBrandIcon" role="presentation" width={32} height={20} alt="Mastercard" />
                  </div>
                  <div className="p-CardBrandIcons-item">
                    <Image src="https://js.stripe.com/v3/fingerprinted/img/amex-a49b82f46c5cd6a96a6e418a6ca1717c.svg" className="p-CardBrandIcon" role="presentation" width={32} height={20} alt="American Express" />
                  </div>
                  <div className="p-CardBrandIcons-item">
                    <Image src="https://js.stripe.com/v3/fingerprinted/img/discover-ac52cd46f89fa40a29a0bfb954e33173.svg" className="p-CardBrandIcon" role="presentation" width={32} height={20} alt="Discover" />
                  </div>
                </div>
              </div>
              <CardNumber className={classNames("ex1-input card-number-input shadow-xs block w-full rounded-xl border-1 border-gray-300 py-4 px-4 pl-5 pr-6 text-[1.03rem] focus:border-indigo-500 focus:ring-indigo-500 my-1")}
                onFocus={() => setHideCardLogos(true)}
                onBlur={(event) => {
                  const element = document.querySelector('.ex1-input.card-number-input');
                  const hasClass = element.classList.contains('invalid') || element.classList.contains('complete');
                  console.log('🚀 ~ file: ChargebeePaymentForm.tsx:208 ~ onBlur ~ hasClass', hasClass);
                  setHideCardLogos(hasClass);
                }}
              />
            </div>

            <div className="col-span-2 sm:col-span-3">
              {/* {!isFromSetup && (<label className="block text-sm font-medium text-gray-700" htmlFor="expiration-date">Expiration date (MM/YY)</label>)} */}
              <div className="mt-1">
                <CardExpiry className="ex1-input shadow-xs my-1 block w-full rounded-xl border-1 border-gray-300 py-4 px-4 pl-5 text-[1.03rem] focus:border-indigo-500 focus:ring-indigo-500" />
              </div>
            </div>
            <div>
              {/* {!isFromSetup && (<label className="block text-sm font-medium text-gray-700" htmlFor="cvc">CVC</label>)} */}
              <div className="mt-1">
                <CardCVV className="ex1-input shadow-xs my-1 block w-full rounded-xl border-1 border-gray-300 py-4 px-4 pl-5 text-[1.03rem] focus:border-indigo-500 focus:ring-indigo-500" />
              </div>
            </div>

            {/* Country Dropdown */}
            <div className={classNames(showZipCode ? "col-span-3" : "col-span-4", !showCountryDropdown && 'hidden')}>
              {/* {!isFromSetup && (<label className="block text-sm font-medium text-gray-700" htmlFor="country">Country</label>)} */}
              <div className="mt-1">
                <select
                  className="ex1-input shadow-xs my-1 block w-full rounded-xl border-1 border-gray-300 py-4 px-4 pl-5 text-[1.03rem] focus:border-indigo-500 focus:ring-indigo-500"
                  id="country"
                  value={selectedCountry}
                  onChange={(e) => {
                    setSelectedCountry(e.target.value);
                    setShowZipCode(['US', 'CA', 'IN', 'AU'].includes(e.target.value));
                  }}
                >
                  {Object.entries(countryList).map(([key, value], index) => (
                    <option key={index} value={key}>{value}</option>
                  ))}
                </select>
              </div>
            </div>
            {/* Zip Code Input */}
            {showZipCode && (
              <div className="col-span-3 sm:col-span-1">
                {/* {!isFromSetup && (<label className="block text-sm font-medium text-gray-700" htmlFor="zip">Zip Code</label>)} */}
                <div className="mt-1">
                  <input
                    className="ex1-input shadow-xs my-1 block w-full rounded-xl border-1 border-gray-300 py-4 px-4 pl-5 text-[1.03rem] focus:border-indigo-500 focus:ring-indigo-500"
                    id="zip"
                    type="text"
                    placeholder="ZIP"
                    autoComplete="postal-code"
                    maxLength={10}
                    title="Please enter a valid zip code."
                    value={zipCode}
                    onChange={(e) => setZipCode(e.target.value)}
                  />
                </div>
              </div>
            )}

          </div>

          <div className="w-full">
            {/* <div className="flex mt-6 space-x-2">
              <div className="flex items-center h-5">
                <input
                  name="same-as-shipping"
                  type="checkbox"
                  defaultChecked
                  className="w-4 h-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500"
                />
              </div>
              <label
                htmlFor="same-as-shipping"
                className="text-sm font-medium text-gray-900"
              >
                Billing address is the same as shipping address
              </label>
            </div> */}

            <Button
              disabled={isLoadingPayment}
              type="submit"
              onClick={onPaymentFormSubmit}
              className={classNames(
                'mt-6 border border relative flex w-full cursor-pointer justify-center gap-2 whitespace-nowrap rounded-xl border-transparent px-4 py-4 text-[0.95rem] shadow-md hover:shadow-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 overflow-hidden ',
                isLoadingPayment
                  ? ' bg-yellow-300  !text-black hover:!bg-yellow-300 hover:!bg-opacity-80 focus:!ring-yellow-500'
                  : ' bg-indigo-600 !text-white hover:!bg-indigo-500  focus:!ring-indigo-500'
              )}
            // className="w-full px-4 py-4 mt-6 font-medium text-white bg-indigo-600 border border-transparent shadow-sm text-nd rounded-xl hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
            >
              {isLoadingPayment ? (
                <div className="relative inline-flex">
                  <LoadingSpinner className="my-auto text-blue-white" />
                  <span>Upgrading...</span>
                </div>
              ) : (
                selectedUsername
                  ? `Start 1-Day Free Trial`
                  : `Upgrade to ${selectedPlan.name} ($${selectedYearly ? selectedPlan.price.YearlyTotal : selectedPlan.price.Monthly})`
              )}
            </Button>

            <p className="flex justify-center mt-6 text-sm font-medium text-gray-500 ">
              <LockClosedIcon className="mr-1.5 h-4 w-4 my-auto text-green-400" aria-hidden="true" />
              Payment details are secured by Stripe
            </p>

            {/* Debugging */}
            {/* <pre className="text-xs max-w-[300px] overflow-x-auto whitespace-pre-wrap">
              {selectedAccount ? JSON.stringify(selectedAccount.data.username) : ''}
              {JSON.stringify(selectedPlan)}
              {JSON.stringify(selectedUsername)}
            </pre> */}

          </div>
        </CardComponent>
      </form>
    </>
  );
}
